module.exports = __webpack_public_path__ + "img/07.fb9e997a.png";